// extracted by mini-css-extract-plugin
module.exports = {"ServiceCard":"styles_ServiceCard__LdTt4","height":"styles_height__IwQ8O"};